var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ps-footer__links pt-2 pb-2"},_vm._l((_vm.footerInfo),function(item){return _c('p',[_c('strong',{staticClass:"mr-1"},[_vm._v("  "+_vm._s(item.title)+"  ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"fotterviews"},[_vm._v(_vm._s(item.desc))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }